var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardTransactionCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F6EEED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.94 14.2101L21.53 19.8201H19.12C18.72 19.8201 18.33 19.8501 17.95 19.9301L18.95 17.5301L18.99 17.4401L19.05 17.2801C19.08 17.2101 19.1 17.1501 19.13 17.1001C20.29 14.4101 21.59 13.5701 23.94 14.2101Z",
    fill: "#8D5245"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7301 20.09L30.7101 20.08C30.1101 19.91 29.5001 19.82 28.8801 19.82H22.6201L24.8701 14.59L24.9001 14.52C25.0401 14.57 25.1901 14.64 25.3401 14.69L27.5501 15.62C28.7801 16.13 29.6401 16.66 30.1701 17.3C30.2601 17.42 30.3401 17.53 30.4201 17.66C30.5101 17.8 30.5801 17.94 30.6201 18.09C30.6601 18.18 30.6901 18.26 30.7101 18.35C30.8601 18.86 30.8701 19.44 30.7301 20.09Z",
    fill: "#8D5245"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.29 21.5201C29.84 21.3901 29.37 21.3201 28.88 21.3201H19.12C18.44 21.3201 17.8 21.4501 17.2 21.7101C15.46 22.4601 14.24 24.1901 14.24 26.2001V28.1501C14.24 28.3901 14.26 28.6201 14.29 28.8601C14.51 32.0401 16.21 33.7401 19.39 33.9501C19.62 33.9801 19.85 34.0001 20.1 34.0001H27.9C31.6 34.0001 33.55 32.2401 33.74 28.7401C33.75 28.5501 33.76 28.3501 33.76 28.1501V26.2001C33.76 23.9901 32.29 22.1301 30.29 21.5201ZM26.5 28.1901H24.75V30.0001C24.75 30.4101 24.41 30.7501 24 30.7501C23.59 30.7501 23.25 30.4101 23.25 30.0001V28.1901H21.5C21.09 28.1901 20.75 27.8601 20.75 27.4401C20.75 27.0301 21.09 26.6901 21.5 26.6901H23.25V25.0001C23.25 24.5901 23.59 24.2501 24 24.2501C24.41 24.2501 24.75 24.5901 24.75 25.0001V26.6901H26.5C26.91 26.6901 27.25 27.0301 27.25 27.4401C27.25 27.8601 26.91 28.1901 26.5 28.1901Z",
    fill: "#8D5245"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardTransactionCardIcon);
export default __webpack_public_path__ + "static/media/dashboard-transaction-card-icon.2ab700f4c8d01796c4c6b98b0fc307e3.svg";
export { ForwardRef as ReactComponent };